import type { Address, Cart } from "@graphql/generated/components";
import type { DeepPartial } from "./types";

export const getCustomField = (item: DeepPartial<Address>, name: string) =>
    item?.custom?.customFieldsRaw?.find((field) => field.name === name)?.value;

export const isCustomFieldAlreadyExistsInCart = (cart: Cart, fieldName: string) => {
    return cart?.custom?.customFieldsRaw?.find((item) => item.name === fieldName)?.value;
};
